import { defineStore } from "pinia";
import { Parameter } from "@/store/search";
import {FavouritesApi} from "@/ api/FavouritesApi";

export type FavouritesStore = {
    isLoading: boolean;
    favourites: Favourite[] | null
}

export const favouritesStore = defineStore({
    id: 'favouritesStore',
    state: () => ({
        isLoading: false,
        favourites: null,
    } as FavouritesStore),
    actions: {
        async fetchFavourites(filter: string) {
            try {
                this.isLoading = true;
                this.favourites = await FavouritesApi.getFavourites(filter)
            } catch (e) {
                console.error(e)
            } finally {
                this.isLoading = false;
            }
        },
        async addFavourites(EntityId: number, Type: number) {
            try {
                this.isLoading = true;
                await FavouritesApi.addFavourites({
                    EntityId,
                    Type,
                })
            } catch (e) {
                console.error(e)
            } finally {
                this.isLoading = false;
            }
        },
        async removeFavourites(EntityId: number, Type: number) {
            try {
                this.isLoading = true;
                await FavouritesApi.removeFavourites({
                    EntityId,
                    Type,
                })

                if (this.favourites?.length === 1) {
                    this.favourites = null
                } else {
                    if (Type === 0) {
                        this.favourites?.splice(this.favourites?.findIndex(fav => fav.Client?.Id === EntityId), 1)
                    } else {
                        this.favourites?.splice(this.favourites?.findIndex(fav => fav.Project?.Id === EntityId), 1)
                    }
                }
            } catch (e) {
                console.error(e)
            } finally {
                this.isLoading = false;
            }
        },
    },
    getters: {
        isFavouritesLoading(state): boolean {
            return state.isLoading
        },
        favouritesList(state): Favourite[] | null {
            return state.favourites
        },
    }
})

export type Favourite = {
    Type: number,
    Title: string,
    Client: {
        Address: string[],
        Parameters: Parameter[],
        Id: number,
        Name: string
    } | null,
    Project: {
        Parameters: Parameter[],
        Id: number,
        Name: string
    } | null
}


